import React, { useEffect } from 'react';
import { Spin, Result } from 'antd';

const AuthCallback = () => {
  useEffect(() => {
    // Get the authorization code from URL parameters
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    const error = urlParams.get('error');

    if (error) {
      // Handle authentication error
      console.error('Authentication error:', error);
      window.close();
      return;
    }

    if (code) {
      // Post the code to the parent window and close
      if (window.opener) {
        window.opener.postMessage({ type: 'GOOGLE_AUTH_SUCCESS', code }, window.location.origin);
        window.close();
      } else {
        // If no opener, redirect to analytics page with code in URL
        window.location.href = `/seo-analytics?code=${code}`;
      }
    }
  }, []);

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      minHeight: '100vh',
      flexDirection: 'column'
    }}>
      <Spin size="large" />
      <p style={{ marginTop: '16px' }}>Processing authentication...</p>
    </div>
  );
};

export default AuthCallback;